module.exports = {
      id: "ic-time-usage",
      viewBox: "0 0 12 12",
      url: __webpack_public_path__ + "sprite-2c53a1.smartcharts.svg#ic-time-usage",
      toString: function () {
        return this.url;
      }
    }